import { ColumnDef } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import EDateText from '@/components/everridge/EDateText';
import SupportEmailRequestStatusBadge from '../components/SupportEmailRequestStatusBadge';
import SupportEmailAiAnalysisStatusBadge from '../components/SupportEmailAiAnalysisStatusBadge';
import SupportEmailRequestCategoryLabel from '../components/SupportEmailRequestCategoryLabel';
import type { SupportEmailRequestListItemDto } from '../types/support-email-request.types';

export const useSupportEmailRequestsPageColumns = (): ColumnDef<SupportEmailRequestListItemDto>[] => {
    const { t } = useTranslation();

    return [
        {
            accessorKey: 'receivedAt',
            header: t('supportEmailRequests.columns.receivedAt'),
            cell: ({ row }) => (
                <EDateText date={new Date(row.original.receivedAt)} />
            ),
        },
        {
            accessorKey: 'category',
            header: t('supportEmailRequests.columns.category'),
            cell: ({ row }) => <SupportEmailRequestCategoryLabel category={row.original.category} />,
        },
        {
            accessorKey: 'status',
            header: t('supportEmailRequests.columns.status'),
            cell: ({ row }) => <SupportEmailRequestStatusBadge status={row.original.status} />,
        },
        {
            accessorKey: 'aiAnalysisStatus',
            header: t('supportEmailRequests.columns.aiAnalysis'),
            cell: ({ row }) => (
                <SupportEmailAiAnalysisStatusBadge status={row.original.aiAnalysisStatus} />
            ),
        },
        {
            accessorKey: 'isSuspicious',
            header: t('supportEmailRequests.columns.suspicious'),
            cell: ({ row }) =>
                row.original.isSuspicious
                    ? t('supportEmailRequests.suspicious.yes')
                    : t('supportEmailRequests.suspicious.no'),
        },
        {
            accessorKey: 'sender',
            header: t('supportEmailRequests.columns.sender'),
        },
        {
            accessorKey: 'recipient',
            header: t('supportEmailRequests.columns.recipient'),
        },
        {
            accessorKey: 'subject',
            header: t('supportEmailRequests.columns.subject'),
            cell: ({ row }) => row.original.subject ?? '—',
        },
        {
            accessorKey: 'attachmentCount',
            header: t('supportEmailRequests.columns.attachments'),
        },
    ];
};
